import color from "@definitions/mui/color";
import { makeStyles } from "@mui/styles";

interface IProps {
  active?: boolean;
  isEdit?: boolean;
  isLogout?: boolean;
  noFullscreen?: boolean;
  isBtnOutline?: boolean;
}

const useStyles = ({ active }: IProps) => {
  return makeStyles(() => ({
    linkMenu: {
      position: "relative",
      "& svg": {
        width: 28,
        height: 28,
      },
      "&:after": {
        content: active ? "''" : "unset",
        width: 20,
        height: 2,
        backgroundColor: color.primary.main,
        borderRadius: 8,
        position: "absolute",
        bottom: 3,
        left: "50%",
        transform: "translateX(-50%)",
      },
    },
  }))();
};

export default useStyles;
